import { Component, OnInit } from '@angular/core';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss'],
})
export class CategoryListComponent implements OnInit {
  categoryList: any[];

  constructor(private panelService: PanelService) {}

  ngOnInit(): void {
    this.getCategories();
  }

  private getCategories() {
    this.panelService
      .getCategoryList({ is_collection: false })
      .subscribe((categories) => {
        this.categoryList = categories.map((c) => ({
          ...c,
          id: c.category_detail.id,
          url: `/category/${c.category_detail.id}/${c.name.replace(/[^a-zA-Z0-9]+/g, '-')}`,
        }));
      });
  }
}
